import React, {PureComponent} from 'react';
import {withTranslation} from 'react-i18next';
import Loading from '../../subComponents/GenericLoading/loading'
import ArrowLeft from "../../../assets/arrow-left.png";
import ArrowRight from "../../../assets/arrow-right.png";
import EditIcon from '../../../assets/edit.png';
import TrashIcon from '../../../assets/trash.png';
import PublishIcon from '../../../assets/publish.png';
import UnpublishIcon from '../../../assets/unpublish.png';
import NewsGalleryBlack from '../../../assets/news_gallery_black.png'
import NewsMultimediaBlack from '../../../assets/news_multimedia_black.png'
import "./index.css";
import Connect from "react-redux/es/connect/connect";
import {alertSuccess, editArticle, getArticle, getArticles, removeArticle} from "../../../actions";
import Pagination from "../../subComponents/GenericPagination";
import Config from "../../../config";
import {
	dispatchOnManageArticlesClickedArticleIdChanged,
	dispatchOnManageArticlesGetArticles,
	dispatchOnManageArticlesGetArticlesFailure,
	dispatchOnManageArticlesGetArticlesSuccess,
	dispatchOnManageArticlesPublishOrUnpublishArticles,
	dispatchOnManageArticlesPublishOrUnpublishArticlesFailure,
	dispatchOnManageArticlesPublishOrUnpublishArticlesSuccess,
	dispatchOnManageArticlesPublishOrUnpublishModeChanged,
	dispatchOnManageArticlesRemoveArticles,
	dispatchOnManageArticlesRemoveArticlesFailure,
	dispatchOnManageArticlesRemoveArticlesSuccess,
	dispatchOnManageArticlesRemoveModeChanged,
} from "./functions";
import {debug, find, formatDateTimeUSToEU} from "../../../utility/functions";
import SuperModal from "../../subComponents/GenericModal/superModal";
import GenericTable from "../../subComponents/GenericTable/GenericTable";
import {dispatchOnCreateArticlesSetArticleToEditChanged, getArticleMode} from "../create/article/functions";
import {getItem, keys} from "../../../localStorage";
import BetterGenericTable from "../../subComponents/BetterGenericTable";
import {GET_SCHOOL_ARTICLES} from "../../../api";

const PUBLISHED = "Publicado";
const TO_APPROVE = "Por aprovar";
const SCHEDULED = "Agendado";
const DRAFT = "Rascunho";

class ManageNews extends PureComponent {

	// Native component functions

	componentDidMount() {
		this.onGetArticles();
	}

	// Custom component functions

	// Fetches all articles from the api and dispatches functions to redux according to the result
	onGetArticles = (url) => {
		this.props.dispatchOnManageArticlesGetArticles();
		getArticles(url)
			.then((response) => {
				debug("Get Articles Success", response);
				this.props.dispatchOnManageArticlesGetArticlesSuccess(response);
			})
			.catch((error) => {
				this.props.dispatchOnManageArticlesGetArticlesFailure(error);
			});
	};

	onGetArticle = (id) => {
		getArticle(id)
			.then(response => {
				debug("article", response.data)
				this.props.dispatchOnCreateArticlesSetArticleToEditChanged(response.data);
				const articleType = getArticleMode(find(response.data, 'layout.path'));
				if (articleType === "gallery") {
					this.props.history.push('/create-news/gallery');
				} else {
					this.props.history.push('/create-news/multimedia');
				}
				this.props.dispatchOnManageArticlesClickedArticleIdChanged(null);
			})
			.catch(error => {

			})
	};

	// This function attempts to edit an existing article with the data provided from the html page
	onEditArticle = (article, index, body) => {
		this.props.dispatchOnManageArticlesPublishOrUnpublishArticles();
		editArticle(find(article, 'id'), body)
			.then(response => {
				debug("Publish / Unpublish article with success", response);
				alertSuccess(response.message);
				this.props.dispatchOnManageArticlesPublishOrUnpublishArticlesSuccess(response.data, index, response);
			})
			.catch((error) => {
				debug("Publish / Unpublish article with failure", error)
				this.props.dispatchOnManageArticlesPublishOrUnpublishArticlesFailure(error);
			})
	};

	// This function attempts to remove an existing article with the data provided from the html page
	onRemoveArticle = (article, index) => {
		this.props.dispatchOnManageArticlesRemoveArticles();
		removeArticle(article)
			.then(response => {
				debug("Remove article with success", response);
				alertSuccess(response.message);
				this.props.dispatchOnManageArticlesRemoveArticlesSuccess(article, index, response);
			})
			.catch((error) => {
				debug("Remove article with failure", error);
				this.props.dispatchOnManageArticlesRemoveArticlesFailure(error);
			})
	};

	// This function is called when the 'pencil' icon is clicked in an article row
	// Calls the Create articles page and edits its html layout to edit the selected article
	onEditPressed = (article) => {
		const id = find(article, 'id')
		this.props.dispatchOnManageArticlesClickedArticleIdChanged(id);
		this.onGetArticle(id);
	};

	// This function is called when the 'trash' icon is clicked in an article row
	// It is responsible for making a modal render with functions to remove the selected article
	onRemovePressed = (article, index) => {
		this.props.dispatchOnManageArticlesRemoveModeChanged(article, index, true)
	};

	// This function is called when the 'eye' icon is clicked in an article row
	// It is responsible for making a modal render with functions to publish/unpublish the selected article
	onPublishUnpublishPressed = (article, index) => {
		this.props.dispatchOnManageArticlesPublishOrUnpublishModeChanged(article, index, true);
	};

	// Returns a string based on data from an article
	getNewsStatus = (e) => {
		if (find(e, 'public') === '1' && find(e, 'scheduled') === 0) return PUBLISHED;
		if (find(e, 'public') === '0' && find(e, 'draft') === 0) return TO_APPROVE;
		if (find(e, 'scheduled') === 1 && find(e, 'draft') === 0) return SCHEDULED;
		return DRAFT
	};

	// Native component render function

	render() {
		const {t} = this.props;
		return (
			<div>
				<div>
					<div className="container-news-manage-header">
						<div className="container-header-tittle"><h2>{t('News')}</h2></div>
						<div className='container-header-arrow'>{">"}</div>
						<div className="container-header-subtittle">{t('Management News')}</div>
					</div>
					<div>
						<BetterGenericTable
							data={this.props.articles}
							columns={[
								{
									rowComponent: (row, index) => {
										const images = find(row, 'images');
										return(
											<img
												style={{height: 24}}
												src={images.length > 1? NewsGalleryBlack : NewsMultimediaBlack}
												alt={""}
											/>
										)
									}
								},
								{
									name: t("Title"),
									value: (item, index) => {
										return find(item, 'title');
									},
									rowClassName: "table-column-list-articles-title",
								},

								{
									name: t("Status"),
									rowComponent: (row, index) => this.renderRowStatus(this.getNewsStatus(row))
								},
								{
									name: t("Submission"),
									value: (item, index) => formatDateTimeUSToEU(find(item, 'publishedDate'))
								},
								{
									name: t("Actions"),
									rowComponent: (row, index) => this.renderRowActions(row, index)
								}
							]}
							loading={this.props.loading}
							loadingComponent={(
								<Loading size={"small-spinner"} color={"blue"}/>
							)}
							emptyTableComponent={t("No articles")}
							rowLoading={(row, index) => {
								return find(row, 'id') === this.props.clickedArticleId;
							}}
							rowLoadingComponent={(
								<div className={'container-dashboard-body-table-row-loading-component'}>
									<Loading size={"small-spinner"} color={"blue"}/>
									<div style={{marginLeft: 8}}>Carregando Artigo</div>
								</div>
							)}
						/>
						{this.renderPaginationButtons()}
					</div>
				</div>
				{this.renderRemoveModal()}
				{this.renderPublishModal()}
			</div>
		);
	}

	renderPublishModal() {
		const {t, inPublishMode, publishing, article, index} = this.props;
		const isPublic = find(article, 'public') === "1";
		if (inPublishMode) {
			return (
				<SuperModal
					onOkPressed={() => {
						const body = {
							strapline: find(article, 'strapline'),
							title: find(article, 'title'),
							lead: find(article, 'lead'),
							body: find(article, 'body'),
							public: isPublic ? 0 : 1,
						};
						this.onEditArticle(article, index, body)
					}}
					onCancelPressed={() => {
						this.props.dispatchOnManageArticlesPublishOrUnpublishModeChanged(null, null, false)
					}}
					onCloseModal={() => {
						this.props.dispatchOnManageArticlesPublishOrUnpublishModeChanged(null, null, false)
					}}
					okButtonColor={isPublic ? 'red' : 'green'}
					okButtonText={isPublic ? t('Unpublish') : t('Publish')}
					cancelButtonText={t('Cancel')}
					title={isPublic ? t("Do you wish to unpublish this article?") : t("Do you wish to publish this article?")}
					okLoading={publishing}
				>
					{
						!isPublic ?
							<text>Confirma que tem os direitos de autor para as imagens e textos inseridos neste
								artigo?</text>
							: null
					}
				</SuperModal>
			)
		}
	}

	renderRemoveModal() {
		const {t, inRemoveMode, removing, article, index} = this.props;
		if (inRemoveMode) {
			return (
				<SuperModal
					size={"lg"}
					onOkPressed={() => {
						this.onRemoveArticle(article, index)
					}}
					onCloseModal={() => {
						this.props.dispatchOnManageArticlesRemoveModeChanged(null, null, false)
					}}
					okButtonText={t('Remove')}
					cancelButtonText={t('Cancel')}
					title={t("Do you wish to remove this article?")}
					okLoading={removing}
					okButtonVariant={"danger"}
				/>
			)
		}
	}

	renderPaginationButtons() {
		if (!this.props.pagination) return;
		const {current_page, last_page} = this.props.pagination;
		return (
			<Pagination
				totalPages={last_page}
				currentPage={current_page}
				baseUrl={Config.urlApi + GET_SCHOOL_ARTICLES}
				onPageChanged={(url) => {
					this.onGetArticles(url)
				}}
			/>
		)
	}

	renderRowStatus(status) {
		switch (status) {
			case DRAFT:
				return <div className="table-status black">{status}</div>
			case PUBLISHED:
				return <div className="table-status green">{status}</div>
			case SCHEDULED:
				return <div className="table-status yellow">{status}</div>
			case TO_APPROVE:
				return <div className="table-status red">{status}</div>
			default:
				return null;
		}

	}

	renderRowActions(e, i) {
		switch (this.getNewsStatus(e)) {
			case PUBLISHED:
				if (getItem(keys.role) === "1") {
					return (
						<div className="container-news-manage-table-row-icons">
							{this.renderEditIcon(e, i)}
							{this.renderTrashIcon(e, i)}
						</div>
					);
				}
			case SCHEDULED:
				if (getItem(keys.role) === "1") {
					return (
						<div className="container-news-manage-table-row-icons">
							{this.renderEditIcon(e, i)}
							{this.renderTrashIcon(e, i)}
						</div>
					);
				}
				break;
			case DRAFT:
				return (
					<div className="container-news-manage-table-row-icons">
						{this.renderEditIcon(e, i)}
						{this.renderTrashIcon(e, i)}
					</div>
				);
			case TO_APPROVE:
				if (getItem(keys.role) === "1") {
					return (
						<div className="container-news-manage-table-row-icons">
							{this.renderEditIcon(e, i)}
							{this.renderPublishIcon(e, i)}
							{this.renderTrashIcon(e, i)}
						</div>
					);
				} else {
					return (
						<div className="container-news-manage-table-row-icons">
							{this.renderEditIcon(e, i)}
							{this.renderTrashIcon(e, i)}
						</div>
					);
				}
			default:
				return null;
		}
	}

	renderEditIcon(e, i) {
		return (
			<img className="container-news-manage-table-row-edit-icon" src={EditIcon}
			     alt={""} onClick={() => this.onEditPressed(e, i)}/>
		)
	}

	renderPublishIcon(e, i) {
		if (getItem(keys.role) === "1") {
			return (
				<img className="container-news-manage-table-row-edit-icon" src={PublishIcon}
				     alt={""} onClick={() => this.onPublishUnpublishPressed(e, i)}/>
			)
		}
	}

	renderUnpublishIcon(e, i) {
		if (getItem(keys.role) === "1") {
			return (
				<img className="container-news-manage-table-row-edit-icon" src={UnpublishIcon}
				     alt={""} onClick={() => this.onPublishUnpublishPressed(e, i)}/>
			)
		}
	}

	renderTrashIcon(e, i) {
		return (
			<img className="container-news-manage-table-row-edit-icon" src={TrashIcon}
			     alt={""} onClick={() => this.onRemovePressed(e, i)}/>
		)
	}
}

const mapStateToProps = store => ({
	loading: store.manageArticlesReducer.loading,
	articles: store.manageArticlesReducer.articles,
	article: store.manageArticlesReducer.article,
	index: store.manageArticlesReducer.index,
	inRemoveMode: store.manageArticlesReducer.inRemoveMode,
	removing: store.manageArticlesReducer.removing,
	inPublishMode: store.manageArticlesReducer.inPublishMode,
	publishing: store.manageArticlesReducer.publishing,
	pagination: store.manageArticlesReducer.pagination,
	clickedArticleId: store.manageArticlesReducer.clickedArticleId,
});

const mapFunctionsToProps = {
	dispatchOnManageArticlesGetArticles,
	dispatchOnManageArticlesGetArticlesSuccess,
	dispatchOnManageArticlesGetArticlesFailure,
	dispatchOnManageArticlesPublishOrUnpublishArticles,
	dispatchOnManageArticlesPublishOrUnpublishArticlesSuccess,
	dispatchOnManageArticlesPublishOrUnpublishArticlesFailure,
	dispatchOnManageArticlesRemoveArticles,
	dispatchOnManageArticlesRemoveArticlesSuccess,
	dispatchOnManageArticlesRemoveArticlesFailure,
	dispatchOnManageArticlesPublishOrUnpublishModeChanged,
	dispatchOnManageArticlesRemoveModeChanged,
	dispatchOnCreateArticlesSetArticleToEditChanged,
	dispatchOnManageArticlesClickedArticleIdChanged
};

export default Connect(mapStateToProps, mapFunctionsToProps)(withTranslation("translations")(ManageNews));